import { type FocusEvent } from 'react';
import {
  type Control,
  Controller,
  type FieldErrors,
  type UseFormResetField,
} from 'react-hook-form';

import { type CardOptionType, useValidate } from 'hooks';
import { type PaymentType } from 'types';
import { Input } from 'views/components/fonbet/ui';

import { type CardFieldsType } from './type';

type Props = {
  control: Control<CardFieldsType, any>;
  selectedCard: CardOptionType;
  paymentData: PaymentType;
  amount: string;
  errors: FieldErrors<CardFieldsType>;
  resetField: UseFormResetField<CardFieldsType>;
  onHandleFocus: (e: FocusEvent<HTMLInputElement>) => void;
};

const DateInput = ({
  control,
  selectedCard,
  paymentData,
  amount,
  errors,
  onHandleFocus,
  resetField,
}: Props) => {
  const { validateCardMoth, validateCardYear } = useValidate();

  return (
    <div className="relative">
      <div className="flex gap-3 lg:mt-0">
        <Controller
          name="month"
          control={control}
          rules={
            selectedCard.newCard
              ? {
                  required: true,
                  validate: validateCardMoth,
                }
              : undefined
          }
          render={({ field: { value, onChange, ref } }) => (
            <Input
              name="month"
              placeholder="MM"
              mask=" "
              format={selectedCard.newCard ? '##' : '**'}
              inputClassName="w-20 md:w-[90px]"
              value={value}
              allowEmptyFormatting={!selectedCard.newCard}
              onChange={onChange}
              onFocus={onHandleFocus}
              clear={() => resetField('month')}
              ref={ref}
              type="tel"
              disabled={paymentData.commission > amount || !selectedCard.newCard}
              error={!!(errors.year?.message || errors.month?.message)}
            />
          )}
        />
        <Controller
          name="year"
          control={control}
          rules={
            selectedCard.newCard
              ? {
                  required: true,
                  validate: validateCardYear,
                }
              : undefined
          }
          render={({ field: { value, onChange, ref } }) => (
            <Input
              name="year"
              placeholder="YY"
              mask=" "
              format={selectedCard.newCard ? '##' : '**'}
              inputClassName="w-20 md:w-[90px]"
              value={value}
              onChange={onChange}
              onFocus={onHandleFocus}
              clear={() => resetField('year')}
              ref={ref}
              type="tel"
              allowEmptyFormatting={!selectedCard.newCard}
              disabled={paymentData.commission > amount || !selectedCard.newCard}
              error={!!(errors.year?.message || errors.month?.message)}
            />
          )}
        />
      </div>
      {(errors.year?.message || errors.month?.message) && (
        <div className="text-fonbet-red text-xs leading-3 text-left mt-1.5 lowercase whitespace-nowrap">
          {errors.year?.message || errors.month?.message}
        </div>
      )}
    </div>
  );
};

export default DateInput;
